import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { Field, getFormSyncErrors, getFormValues, reduxForm } from "redux-form";
import { Link } from "react-router-dom";
import { renderTextField } from "components/FormFields/FieldTypes";
import { PhoneNumberRequired } from "components/FormFields/validators";
import { phone as phoneFormatter } from "components/FormFields/formatters";
import { phone as phoneValidator } from "components/FormFields/normalizers";
import { connect } from "react-redux";
import { homeActions } from "actions";

const SendHCPTextMessagePopUp = (props) => {
  const {
    showSendTextMessage,
    onCancel,
    formErrors,
    shareHCPCoupon,
    formValues,
    sendHcpTextMessageInfo,
    showTextCoupon = false,
    updateGTMDataLayer,
    organizationInfo,
    shareCoupon = false,
    shareApp = false,
    couponData = null,
    selectedInsurance,
    resetHCPSendTextInfo,
    sendHcpTextMessageIisProgress,
    reset,
    viewCouponLinkClick = null,
    viewCouponLink = false,
    disableCancelBtn = false,
  } = props;

  console.log(shareApp);
  const theme = useTheme();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);

  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    updateGTMDataLayer({
      event: couponData
        ? "Get_hcp_savings_share_text_attempt"
        : "Get_hcp_site_share_text_attempt",
      action: "attempting text share coupon",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
    });
    return () => {
      setShowSuccess(false);
      setShowFailure(false);
      resetHCPSendTextInfo();
      reset();
    };
  }, []);

  useEffect(() => {
    setShowFailure(false);
    setShowSuccess(false);
    if (
      sendHcpTextMessageInfo &&
      sendHcpTextMessageInfo.data &&
      sendHcpTextMessageInfo.success
    ) {
      setShowSuccess(true);
    }
    if (
      Object.keys(sendHcpTextMessageInfo).length &&
      !sendHcpTextMessageInfo.data &&
      !sendHcpTextMessageInfo.success
    ) {
      setShowFailure(true);
    }
  }, [sendHcpTextMessageInfo]);

  const onSubmitPopUpData = () => {
    console.log(couponData);
    const storedInsuranceData = JSON.parse(
      localStorage.getItem("storedInsuranceData")
    );
    let data = {
      productDetailId: null,
      quantity: 0.0,
      insuranceId: null,
      phoneNumber: null,
      email: null,
    };
    if (shareCoupon) {
      data = {
        productDetailId: couponData?.productDetailId,
        quantity: 0.0,
        insuranceId: selectedInsurance?.id || storedInsuranceData?.id,
        phoneNumber: null,
        email: null,
        pharmacyGroupId: couponData?.pharmacyGroupId || null,
      };
    }
    shareHCPCoupon({
      ...data,
      ...formValues,
      email: null,
    });
    updateGTMDataLayer({
      event: couponData
        ? "Get_hcp_savings_share_text"
        : "Get_hcp_site_share_text",
      action: "completed text share coupon",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      ...formValues,
    });
  };

  const onSuccessDone = () => {
    setShowSuccess(false);
    onCancel();
    reset();
  };

  const onFailedDone = () => {
    setShowFailure(false);
    onCancel();
    reset();
  };

  const renderLayout = () => {
    return (
      <DialogContent
        sx={{
          paddingLeft: matchesMinWidth ? "24px" : "40px",
          paddingRight: matchesMinWidth ? "24px" : "40px",
          paddingTop: showTextCoupon ? "0px" : undefined,
        }}
      >
        {sendHcpTextMessageIisProgress ? (
          <div
            style={{
              height: "300px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <CircularProgress
              style={{ color: theme?.palette?.secondary?.main }}
            />
          </div>
        ) : !showSuccess && !showFailure ? (
          <Box
            component="div"
            sx={{
              textAlign: "center",
              width: matchesMinWidth ? undefined : "500px",
              padding: matchesMinWidth ? "16px 5px" : "20px",
              borderRadius: "20px",
            }}
          >
            <Box mb={3}>
              <Typography
                variant="h2LatoMedium"
                sx={{
                  fontWeight: 500,
                  fontSize: 16,
                  textAlign: "center",
                  color: "#607277",
                }}
              >
                Enter patient’s phone number (sender’s phone number will not be
                revealed) :
              </Typography>
            </Box>
            <Box mb={5}>
              <Field
                name="phoneNumber"
                isRequired
                component={renderTextField}
                label="Mobile phone number"
                validate={[PhoneNumberRequired]}
                format={phoneFormatter}
                normalize={phoneValidator}
              />
            </Box>
            <Box mb={3} sx={{ textAlign: "center" }}>
              <Typography variant="h4LatoBold" sx={{ fontSize: "12px" }}>
                By continuing to use this website, you agree to the <br />
                Cuverd{" "}
                <Box
                  component={Link}
                  to="/terms-and-conditions"
                  sx={
                    {
                      //textDecoration: "none",
                    }
                  }
                >
                  <Typography
                    component={"span"}
                    sx={{ fontSize: "12px" }}
                    variant="h3LatoBoldNew"
                  >
                    Terms and Conditions
                  </Typography>
                </Box>{" "}
                and{" "}
                <Box
                  component={Link}
                  to="/privacy-policy"
                  sx={
                    {
                      //textDecoration: "none",
                    }
                  }
                >
                  <Typography
                    component={"span"}
                    sx={{ fontSize: "12px" }}
                    variant="h3LatoBoldNew"
                  >
                    Privacy Policy
                  </Typography>
                </Box>{" "}
              </Typography>
            </Box>
            <Box mb={4}>
              <Button
                variant="large"
                type="button"
                onClick={() => onSubmitPopUpData()}
                disabled={Object.keys(formErrors).length ? true : false}
                sx={{
                  backgroundColor: Object.keys(formErrors).length
                    ? "#e6e6e6"
                    : `${organizationInfo?.colorSchemeJson?.primaryButtonColor}`,
                  width: matchesMinWidth ? undefined : "100%",
                  fontSize: matchesMinWidth ? "14px" : undefined,
                  minWidth: matchesMinWidth ? "200px" : undefined,
                  color: Object.keys(formErrors).length
                    ? "#637276"
                    : `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: `${organizationInfo?.colorSchemeJson?.primaryButtonColor}`,
                  },
                }}
              >
                SEND
              </Button>
            </Box>
            {viewCouponLink && viewCouponLinkClick && (
              <Box mx="auto" sx={{ width: "100%" }}>
                <Button
                  variant="text"
                  sx={{
                    width: matchesMinWidth ? undefined : "100%",
                    fontSize: matchesMinWidth ? "14px" : undefined,
                    minWidth: matchesMinWidth ? "200px" : undefined,
                    textDecoration: "underline",
                    //color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                  }}
                  onClick={() => {
                    onCancel();
                    viewCouponLinkClick();
                  }}
                >
                  View Savings
                </Button>
              </Box>
            )}
            {!disableCancelBtn && (
              <Box mx="auto" sx={{ width: "100%" }}>
                <Button
                  variant="text"
                  sx={{
                    width: matchesMinWidth ? undefined : "100%",
                    fontSize: matchesMinWidth ? "14px" : undefined,
                    minWidth: matchesMinWidth ? "200px" : undefined,
                    textDecoration: "underline",
                    //color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                  }}
                  onClick={onCancel}
                >
                  CANCEL
                </Button>
              </Box>
            )}
          </Box>
        ) : (
          <Box sx={{ textAlign: "center" }}>
            {showSuccess ? (
              <Box>
                <Box mb={4} mt={2}>
                  <Typography variant="h2LatoBold">
                    {shareApp ? "Website" : "Coupon"} sent!
                  </Typography>
                </Box>
                <Box mb={7}>
                  <Typography variant="h2LatoMedium">
                    You have successfully sent the{" "}
                    {shareApp ? "website" : "coupon"} to{" "}
                    {phoneFormatter(formValues?.phoneNumber)}.
                  </Typography>
                </Box>
                <Box mb={4}>
                  <Button
                    variant="large"
                    sx={{
                      minWidth: { xs: "150px", sm: "100%", md: undefined },
                    }}
                    onClick={() => onSuccessDone()}
                  >
                    OK
                  </Button>
                </Box>
              </Box>
            ) : null}
            {showFailure ? (
              <Box>
                <Box mt={3}>
                  <Typography variant="h2LatoBold">Send Text Error</Typography>
                </Box>
                <Box my={3}>
                  <Typography variant="h2LatoMedium">
                    {sendHcpTextMessageInfo?.message}
                  </Typography>
                </Box>
                <Box>
                  <Button variant="large" onClick={() => onFailedDone()}>
                    OK
                  </Button>
                </Box>
              </Box>
            ) : null}
          </Box>
        )}
      </DialogContent>
    );
  };

  return (
    <>
      {showTextCoupon ? (
        renderLayout()
      ) : (
        <Box>
          <Dialog
            open={showSendTextMessage}
            className="app-dialog"
            onClose={onCancel}
          >
            {renderLayout()}
          </Dialog>
        </Box>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("SEND_TEXT_PHONE_NUMBER_FORM")(state) || {},
    formValues: getFormValues("SEND_TEXT_PHONE_NUMBER_FORM")(state),
    sendHcpTextMessageInfo: state.sendHcpTextMessageInfo.data,
    organizationInfo: state.organizationInfo.data || {},
    selectedInsurance: state.insuranceList.selectedInsurance,
    sendHcpTextMessageIisProgress: state.sendHcpTextMessageInfo.isProgress,
  };
};

const mapDispatchToProps = {
  shareHCPCoupon: (params) => homeActions.shareHCPCoupon(params),
  resetHCPSendTextInfo: () => homeActions.resetHCPSendTextInfo(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "SEND_TEXT_PHONE_NUMBER_FORM",
  })(SendHCPTextMessagePopUp)
);
